import { showWarningMessage } from "../_uiComponents/ShowMessageSnack";

const useDisableChange = () => {
  const handleVisibilityChange = () => {
    if (document.hidden) {
      showWarningMessage(
        "You are trying to switch tabs. Please stay on this tab."
      );
      window.focus();
    }
    document.addEventListener("visibilitychange", handleVisibilityChange);
  };

  return {
    handleVisibilityChange,
  };
};

export default useDisableChange;
